// extracted by mini-css-extract-plugin
module.exports = {"content_wrap":"createNewCriteria_content_wrap__2cyCh","info_box":"createNewCriteria_info_box__1u7tQ","scale_info":"createNewCriteria_scale_info__3MVOE"};